import { useEffect, useRef, useState } from "react";
import { FaCheck, FaEye, FaEyeSlash } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
//import { setSubLoading } from "../Redux/Services/AuthSlice";
import { ApiCall, encryptPassword, sanitizeInput } from "../CommonComponents/CustomHooks";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { FormButton, InputBox } from "../CommonComponents/InputBox";
import { LockKeyholeOpen } from 'lucide-react';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
const ChangePassword = () => {
    const inputrefs = useRef([]);
    const dispatch = useDispatch([]);
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false,
    });

    const [changePasswordData, setChangePasswordData] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [policyValidations, setPolicyValidations] = useState({
        noWhitespace: false,
        length: false,
        matchConfirmPassword: false,
        differentOldPassword: false,
        complexity: false,
    });

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true));
        let data = await ApiCall(`/api/ClientUser/ChangePassword`, {
            ...changePasswordData,
            oldPassword: (changePasswordData.oldPassword),
            newPassword: (changePasswordData.newPassword),
            confirmPassword: (changePasswordData.confirmPassword),
        });
        await dispatch(setSubLoading(false));
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleReset);
        if (data.status === "SUCCESS") {
            navigate("/");
        }
    };

    const handleReset = () => {
        setChangePasswordData({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
        });
        setPolicyValidations({
            noWhitespace: false,
            length: false,
            matchConfirmPassword: false,
            differentOldPassword: false,
            complexity: false,
        });
        setShowPassword({
            oldPassword: false,
            newPassword: false,
            confirmPassword: false,
        });
    };

    const handleTogglePassword = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const validatePassword = (password, confirmPassword) => {
        if (password !== "") {
            const noWhitespace = !/\s/.test(password);
            const length = password.length >= 8 && password.length <= 15;
            const complexity =
                /[A-Z]/.test(password) &&
                /[a-z]/.test(password) &&
                /[0-9]/.test(password) &&
                /[!@#$%^&*(),.?":{}|<>]/.test(password);

            setPolicyValidations({
                noWhitespace,
                length,
                matchConfirmPassword: password === confirmPassword,
                differentOldPassword: password !== changePasswordData.oldPassword,
                complexity,
            });
        } else {
            setPolicyValidations({
                noWhitespace: false,
                length: false,
                matchConfirmPassword: false,
                differentOldPassword: false,
                complexity: false,
            });
        }
    };

    const handlePasswordChange = (field, value) => {
        setChangePasswordData({ ...changePasswordData, [field]: value });
        if (field === "newPassword") {
            validatePassword(value, changePasswordData.confirmPassword);
        } else if (field === "confirmPassword") {
            validatePassword(changePasswordData.newPassword, value);
        }
    };

    useEffect(() => {
        document.title = "Change Password";
        inputrefs.current["txtOldPassword"].focus();
    }, []);

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        <LockKeyholeOpen className="w-5 h-5 text-primary-600" />
                        <h2 className="text-xl font-semibold text-primary-600">Change Password</h2>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="col-span-1 space-y-4">

                        <div className="relative">
                            <InputBox
                                id="txtOldPassword"
                                type={showPassword.oldPassword ? "text" : "password"}
                                label="Old Password"
                                divclassname='w-full mb-3'
                                placeholder="Enter Old Password"
                                required={true}
                                inputrefs={inputrefs}
                                maxLength="15"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") inputrefs.current["txtNewPassword"].focus();
                                }}
                                value={changePasswordData.oldPassword}
                                onChange={(e) =>
                                    setChangePasswordData({
                                        ...changePasswordData,
                                        oldPassword: sanitizeInput(e.target.value),
                                    })
                                }
                            />
                            <span
                                className="absolute right-3 top-[25px] cursor-pointer text-gray-500"
                                onClick={() => handleTogglePassword("oldPassword")}
                            >
                                {showPassword.oldPassword ? <FaEyeSlash className='text-blueled' /> : <FaEye className='text-blueled' />}
                            </span>
                        </div>
                        <div className="relative">
                            <InputBox
                                id="txtNewPassword"
                                divclassname='w-full mb-3'
                                type={showPassword.newPassword ? "text" : "password"}
                                label="New Password"
                                placeholder="Enter New Password"
                                required={true}
                                maxLength="15"
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") inputrefs.current["txtConfirmPassword"].focus();
                                }}
                                value={changePasswordData.newPassword}
                                onChange={(e) => handlePasswordChange("newPassword", e.target.value)}
                            />
                            <span
                                className="absolute right-3 top-[25px] cursor-pointer text-gray-500"
                                onClick={() => handleTogglePassword("newPassword")}
                            >
                                {showPassword.newPassword ? <FaEyeSlash className='text-blueled' /> : <FaEye className='text-blueled' />}
                            </span>
                        </div>
                        <div className="relative">
                            <InputBox
                                id="txtConfirmPassword"
                                type={showPassword.confirmPassword ? "text" : "password"}
                                label="Confirm Password"
                                placeholder="Enter Confirm Password"
                                required={true}
                                divclassname='w-full mb-3'
                                maxLength="15"
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") inputrefs.current["btnSub"].focus();
                                }}
                                value={changePasswordData.confirmPassword}
                                onChange={(e) => handlePasswordChange("confirmPassword", e.target.value)}
                            />
                            <span
                                className="absolute right-3 top-[25px] cursor-pointer text-gray-500"
                                onClick={() => handleTogglePassword("confirmPassword")}
                            >
                                {showPassword.confirmPassword ? <FaEyeSlash className='text-blueled' /> : <FaEye className='text-blueled' />}
                            </span>
                        </div>
                        <FormButton
                            id={"btnSub"}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            Export={false}
                            handleClear={handleReset}
                        />
                    </div>
                    <div className="col-span-2 bg-gray-50 rounded-xl shadow-sm">
                        <div className="bg-blueled px-2 py-2 rounded-t-xl">
                            <h6 className="font-semibold fw-bold fs-5 text-sm">Password Policy</h6>
                        </div>
                        <div className="p-2">
                            <ol className="list-decimal list-inside space-y-2 text-sm text-gray-700 border-0">
                                <li>
                                    White spaces not allowed.{" "}
                                    {policyValidations.noWhitespace ? (
                                        <FaCheck className="inline text-green-600" />
                                    ) : (
                                        <ImCross className="inline text-red-600 text-xs" />
                                    )}
                                </li>
                                <li>
                                    Password must be 8 to 15 character(s).{" "}
                                    {policyValidations.length ? (
                                        <FaCheck className="inline text-green-600" />
                                    ) : (
                                        <ImCross className="inline text-red-600 text-xs" />
                                    )}
                                </li>
                                <li>
                                    New password and confirm password should be same.{" "}
                                    {policyValidations.matchConfirmPassword ? (
                                        <FaCheck className="inline text-green-600" />
                                    ) : (
                                        <ImCross className="inline text-red-600 text-xs" />
                                    )}
                                </li>
                                <li>
                                    Old password and new password should be different.{" "}
                                    {policyValidations.differentOldPassword ? (
                                        <FaCheck className="inline text-green-600" />
                                    ) : (
                                        <ImCross className="inline text-red-600 text-xs" />
                                    )}
                                </li>
                                <li>
                                    Password must contain at least one number, uppercase, lowercase and special character
                                    [$#!()].{" "}
                                    {policyValidations.complexity ? (
                                        <FaCheck className="inline text-green-600" />
                                    ) : (
                                        <ImCross className="inline text-red-600 text-xs" />
                                    )}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;